module.exports = __webpack_public_path__ + "static/media/webstat.03ea24de.JPG";